import styled from 'styled-components';
import { overlayContentZIndex } from 'pages/components/Modal/Modal.styled';

export const Anchor = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  cursor: zoom-in;
`;

export const PreviewPopup = styled.div<{ $size: number, $circle?: boolean }>`
  position: fixed;
  z-index: ${overlayContentZIndex + 10};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  padding: ${({ $circle }) => ($circle ? 3 : 4)}px;
  border-radius: ${({ $circle }) => ($circle ? '50%' : '16px')};
  background: #fff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
  box-sizing: border-box;
`;

export const PreviewImg = styled.img<{ $circle?: boolean }>`
  width: 100%;
  height: 100%;
  border-radius: ${({ $circle }) => ($circle ? '50%' : '12px')};
  object-fit: cover;
  display: block;
  background: #eef1f4;
`;

/** Empty-photo enlarge — same slot as the image, inner thumb fills the circle/card. */
export const PreviewFallback = styled.div<{ $circle?: boolean, $size: number }>`
  width: 100%;
  height: 100%;
  border-radius: ${({ $circle }) => ($circle ? '50%' : '12px')};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f4;
  font-size: ${({ $size }) => Math.round($size * 0.4)}px;
  font-weight: 700;
  line-height: 1;

  & > * {
    width: 100% !important;
    height: 100% !important;
    max-width: none;
    border-radius: inherit;
    box-sizing: border-box;
  }

  & svg {
    width: 55% !important;
    height: 55% !important;
  }
`;
